import api_export from './api'

export const api = api_export
export * from './history'
export * from './memoriam.api'
export * from './api_max'
